import { render, staticRenderFns } from "./IconDefaultTutorPicture.vue?vue&type=template&id=46061bd4&"
import script from "./IconDefaultTutorPicture.vue?vue&type=script&lang=js&"
export * from "./IconDefaultTutorPicture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports